
import {
  TrendingUpIcon,
  BeakerIcon,
  GiftIcon,
  CheckCircleIcon,
  PhoneIncomingIcon,
  ChatAltIcon,
  PlayIcon,
} from "@vue-hero-icons/outline";
const TrialButton = () => import("~/components/Cafe/TrialButton.vue");
const IntroductionModal = () =>
  import("~/components/Cafe/IntroductionModal.vue");
import { CONTANTS } from "~/constants";
import CustomerSupport from "~/components/Common/CustomerSupport.vue";

export default {
  components: {
    TrendingUpIcon,
    BeakerIcon,
    GiftIcon,
    CheckCircleIcon,
    PhoneIncomingIcon,
    ChatAltIcon,
    PlayIcon,
    TrialButton,
    IntroductionModal,
    CustomerSupport,
  },

  layout: "default",

  head() {
    return {
      title: this.metaTitle,
      meta: [
        { hid: "title", name: "title", content: this.metaTitle },
        { hid: "description", name: "description", content: this.metaDesc },
        { hid: "image", name: "image", content: this.metaImage },
        { hid: "og:url", property: "og:url", content: this.routePath },
        { hid: "og:title", property: "og:title", content: this.metaTitle },
        { hid: "og:image", property: "og:image", content: this.metaImage },
        {
          hid: "og:image:secure_url",
          property: "og:image:secure_url",
          content: this.metaImage,
        },
        {
          hid: "og:image:secure",
          property: "og:image:secure",
          content: this.metaImage,
        },
        {
          hid: "og:image:alt",
          property: "og:image:alt",
          content: this.metaTitle,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.metaDesc,
        },
        {
          hid: "twitter:title",
          name: "twitter:title",
          content: this.metaTitle,
        },
        {
          hid: "twitter:image:alt",
          name: "twitter:image:alt",
          content: this.metaTitle,
        },
        {
          hid: "twitter:description",
          name: "twitter:description",
          content: this.metaDesc,
        },
        {
          hid: "twitter:image",
          name: "twitter:image",
          content: this.metaImage,
        },
      ],
      link: [
        {
          hid: "canonical",
          rel: "canonical",
          href: `${this.canonical}`,
        },
      ],
      script: [
        {
          innerHTML: `{
            "@context": "http://schema.org",
            "@type": "NewsArticle",
            "mainEntityOfPage": {
              "@type": "WebPage",
              "@id": "${this.routePath}"
            },
            "headline": "${this.metaTitle}",
            "image": "${this.metaImage}",
            "datePublished": "${this.datePublished}",
            "dateModified": "${this.datePublished}",
            "author": {
              "@type": "Person",
              "name": "${CONTANTS.SITE_SHORT}",
              "url": "${this.routePath}"
            },
            "publisher": {
              "@type": "Organization",
              "name": "${CONTANTS.SITE_SHORT}",
              "logo": {
                "@type": "ImageObject",
                "url": "${this.metaImage}"
              }
            }
          }`,
          type: "application/ld+json",
        },
      ],
      __dangerouslyDisableSanitizers: ["script"],
    };
  },
  computed: {
    customer() {
      return this.$get(this.$$users, "user", "");
    },

    datePublished() {
      return new Date().toISOString();
    },
    metaTitle() {
      return `${this.$t("guide.title")} | ${CONTANTS.SITE_SHORT}`;
    },

    metaDesc() {
      return `${this.$t("guide.desc")} | ${CONTANTS.SITE_SHORT}`;
    },

    metaImage() {
      return `${this.$config.protocol}://${this.$config.baseHost}/images/metacanhanf.jpeg`;
    },

    routePath() {
      return `http://${this.$config.baseHost}${this.$nuxt.context.route?.fullPath}`;
    },

    canonical() {
      return `https://${this.$config.baseHost}${this.$nuxt.context.route?.fullPath}`;
    },
  },

  methods: {
    scrollTo(id) {
      const el = document.getElementById(id);
      if (!el) return;
      // adjust offset if you have a fixed header; set to 0 if none
      const headerOffset = 80;
      const elementPosition =
        el.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    },
  },
};
